/** Logo LifeHub : carré arrondi `--ink` avec « L » serif. En-tête des écrans d'authentification. */
export function Logo({ size = 56 }: { size?: number }) {
  return (
    <span className="lh-logo" role="img" aria-label="LifeHub" style={{ width: size, height: size, borderRadius: Math.round(size * 0.3), fontSize: Math.round(size * 0.5) }}>
      L
    </span>
  );
}
